import { ApiError } from "../../api/client";

/** Cause d'un échec de lecture, pour un message juste (audit du 03/10/2026) : `unreachable` — le serveur n'a pas
 *  répondu (réseau coupé, serveur arrêté : la requête échoue, ou le relais frontal répond 502, 503 ou 504) ;
 *  `server` — il a répondu par une erreur (500…) : le réseau n'y est pour rien, réessayer peut ne rien changer. */
export type LoadFailure = "unreachable" | "server";

export function loadFailure(error: unknown): LoadFailure {
  // Statut 0 : aucune réponse (échec réseau, `UNREACHABLE`).
  if (error instanceof ApiError) return [0, 502, 503, 504].includes(error.status) ? "unreachable" : "server";
  return "unreachable";
}
